import _BaseController from 'Controllers/Web/_BaseController';
import ListController from 'Vue/Web/Common/Lecturer/ListController.vue';
import Datalayer from 'Controllers/Web/Datalayer';

global.Controller = new (class extends _BaseController {
  ListControllerVue?: Vue;

  ready() {
    super.ready();

    // datalayer
    if(Json.datalayer){
      Datalayer.push(Json.datalayer);
    }
    this.ListControllerVue = new Vue(ListController);
  }
})();
